'use client';
import React from 'react';
import { useCheckoutStore } from '../store/checkoutStore';

interface OrderButtonProps {
  size?: 'md' | 'lg';
  label?: string;
}

export default function OrderButton({ size = 'md', label = 'Order Access' }: OrderButtonProps) {
  const openModal = useCheckoutStore((s) => s.openModal);

  const sizeClasses = size === 'lg' ?'px-10 py-5 text-lg' :'px-6 py-3 text-base';

  return (
    <button
      onClick={openModal}
      className={`btn-primary ${sizeClasses} font-bold inline-flex items-center gap-3 glow-gold-sm`}
      aria-label="Order access to Luminary X Pro"
    >
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M13 10V3L4 14h7v7l9-11h-7z" />
      </svg>
      {label}
    </button>
  );
}